<template>
  <section class="main-container categoreis-home">

    <div v-if="categories && categories.length" id="categoreis-slider" class="categoreis-slider position-relative">
      <BigTitle class="mb-2 mb-sm-4" title="دسته بندی های محبوب" />

      <div class="swiper-container ">
        <div class="swiper-wrapper">
          <div class="swiper-slide " v-for="(category, index) in categories" :key="index">
            <CardCategore :data="category" :key="category.id" />
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";
import BigTitle from "@/parts/Front/nicecomponents/shared/BigTitle";

import CardCategore from "@/parts/Front/components/HomeCategoreis/card.vue";

import { BSkeletonImg } from "bootstrap-vue";

export default {
  name: "HomeCategoreis",
  inject: ["mediaQueries"],
  components: {

    CardCategore,
    BSkeletonImg,
    BigTitle
  },

  inject: ["mediaQueries"],

  methods: {
    initCategoreis(kill = false) {
      this.initSwiper("categoreis-home", kill, () => {
        new Swiper("#categoreis-slider .swiper-container", {
          spaceBetween: 30,

          loop: true,
          speed: 1400,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: "#categoreis-slider .swiper-button-next",
            prevEl: "#categoreis-slider .swiper-button-prev",
          },

          breakpoints: {
            // 300: {
            //   slidesPerView: 2,
            //   spaceBetween: 10,
            // },
            // 600: {
            //   slidesPerView: 3,
            //   spaceBetween: 15,
            // },
            // 992: {
            //   slidesPerView: 4,
            //   spaceBetween: 20,
            // },
            // 1100: {
            //   slidesPerView: 5,
            //   spaceBetween: 20,
            // },
            // 1280: {
            //   slidesPerView: 5,
            //   spaceBetween: 20,
            // },
            300: {
              slidesPerView: 2.3,
              spaceBetween: 10,
            },
            600: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1100: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
            1280: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          },
        });
      });
    },
    getEnough(array) {
      return [...array].splice(0, Math.min(array.length, this.showCount));
    },
  },
  mounted() {
    this.initCategoreis();
  },
  watch: {
    categories() {
      this.initCategoreis();
    },

  },
  computed: {
    showCount() {
      if (this.mediaQueries.xxxLarge) {
        return 10;
      }
      if (this.mediaQueries.xxLarge) {
        return 9;
      }

      return 9;
    },
    categories() {

      if (this.$store.getters["front/getHomeData"] == null) {
        return null;
      } else {
        return this.getEnough(
          this.$store.getters["front/getHomeData"].special_categories
        );
      }
    },

  },


};
</script>

<style scoped>
.categoreis-home {
  margin-top: 70px;
}

.swiper-button-prev,
.swiper-button-next {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  position: absolute;
  border: 1px solid #e9e9e9;
  transition: all 0.3s;
}

.swiper-button-next {
  right: -20px;
}

.swiper-button-prev {
  left: -20px;
}

.categoreis-home .swiper-button-prev:hover,
.categoreis-home .swiper-button-next:hover {
  background-color: #000;
}

.categoreis-home .swiper-button-prev .bi path {
  stroke-width: 3px;
}

.categoreis-home .swiper-button-prev:hover .bi path,
.categoreis-home .swiper-button-next:hover .bi path {
  fill: #fff;
}

@media screen and (max-width: 639px) {

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  .categoreis-home {
    margin-top: 40px;
  }
}
</style>
<style>
.categoreis-home .swiper-wrapper {
  padding: 8px 0;
}

.categoreis-home .swiper-button-prev:after,
.categoreis-home .swiper-container-rtl .swiper-button-next:after,
.categoreis-home .swiper-button-next:after,
.categoreis-home .swiper-container-rtl .swiper-button-prev:after {
  display: none;
}

@media screen and (max-width: 639px) {}
</style>
